import React from 'react';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';


const useStyles = makeStyles((theme) => ({
    root: {
      '& > *': {
        margin: theme.spacing(1),
        width: '25ch',
      
      },
    },
  }));

  


function Meme(props){
    const classes = useStyles();
    return (
        <div style={{padding:"30px"}}>
            <div className={classes.root} style={{margin_botton:"10px"}}>
            <TextField id="standard-basic" label="First Caption"  style={{margin:"10px"}} name="first" onChange={props.handle}/>
            <TextField id="standard-basic" label="Second Caption" style={{margin:"10px"}} name="second"  onChange={props.handle} />
          
            </div>
            <Button variant="contained" color="primary" onClick={()=>{
                    return props.generate()
                }}>
                Generate
            </Button>
        <div className='imagecontainer'>
            <img src={props.url} className="img-fluid image" />
        </div>
        </div>
        
    )
}

export default Meme